// extracted by mini-css-extract-plugin
module.exports = {"order":"_2L6QRdKm","order-label":"_1O5UeHqZ","order-value":"_36VSj4zy","total":"_1MA9jaau","total-label":"_1TqnJyMH","total-value":"ZXN1XJ11","actions":"_3SWGHezD"};